var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "action-checklist--item" }, [
    _c("div", [_c("Icon", { attrs: { icon: _vm.icon, color: _vm.color } })], 1),
    _vm._v(" "),
    _c(
      "div",
      {},
      [
        _vm.status === "done"
          ? [
              _vm.confirmationDate
                ? _c("span", [
                    _c("b", [_vm._v(_vm._s(_vm.type))]),
                    _vm._v(" am "),
                    _c("b", [
                      _vm._v(_vm._s(_vm._f("date")(_vm.confirmationDate)))
                    ]),
                    _vm._v(" bestätigt\n\t\t\t")
                  ])
                : _c("span", [
                    _c("b", [_vm._v(_vm._s(_vm.type))]),
                    _vm._v(" bestätigt\n\t\t\t")
                  ])
            ]
          : _vm.status === "questionable"
          ? _c("span", [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.type) +
                    " hochgeladen, Prüfung durch skilldoo offen"
                )
              ])
            ])
          : _vm.status === "open"
          ? _c("span", [
              _c("b", [_vm._v(_vm._s(_vm.type) + " noch nicht bestätigt")])
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.status === "open" && _vm.withConfirmNow
      ? _c(
          "div",
          [
            _c("Button", {
              attrs: { text: "Jetzt bestätigen", smaller: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("confirmNow")
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }